import { useHydrated } from "@tanstack/react-router";

export function useHydratedValue<Value, Before>(
    value: Value,
    beforeHydration: Before,
): Value | Before {
    return useHydrated() ? value : beforeHydration;
}
